const LABELS = {
  VALIDITY: 'Vigência:'
};

export default LABELS;
